import JsCookie from 'js-cookie';

/**
 * references
 * https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag
 * https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag
 */

class DataLayer {
  addToCart(product) {
    const cookie_consent = !!JsCookie.get('statistics_cookies_consent');
    if (cookie_consent && typeof gtag === 'function') {
      // eslint-disable-next-line no-undef
      gtag('event', 'add_to_cart', {
        currency: 'EUR',
        value: parseFloat(product.price * product.quantity),
        items: [{
          item_name: product.name,
          item_id: product.id,
          price: product.price,
          quantity: product.quantity,
          item_brand: 'FL Technics Training',
          currency: 'EUR'
        }]
      });
    }
  }

  removeFromCart(product) {
    const cookie_consent = !!JsCookie.get('statistics_cookies_consent');
    if (cookie_consent && typeof gtag === 'function') {
      // eslint-disable-next-line no-undef
      gtag('event', 'remove_from_cart', {
        currency: 'EUR',
        value: parseFloat(product.price),
        items: [{
          item_name: product.name,
          item_id: product.id,
          price: product.price,
          quantity: product.quantity,
          item_brand: 'FL Technics Training',
          currency: 'EUR'
        }]
      });
    }
  }

  productsListView(products) {
    const cookie_consent = !!JsCookie.get('statistics_cookies_consent');
    if (cookie_consent && typeof gtag === 'function') {
      const list_name = location.pathname.substring(1) ? location.pathname.substring(1).replaceAll('/', '-') : 'landing';
      // eslint-disable-next-line no-undef
      gtag('event', 'view_item_list', {
        item_list_id: list_name,
        item_list_name: list_name.replaceAll('-', ' '),
        items: products
      });
    }
  }

  productView(products) {
    const cookie_consent = !!JsCookie.get('statistics_cookies_consent');
    if (cookie_consent && typeof gtag === 'function') {
      // eslint-disable-next-line no-undef
      gtag('event', 'view_item', {
        currency: 'EUR',
        value: parseFloat(products[0].price),
        items: products
      });
    }
  }

  productClick(product) {
    const cookie_consent = !!JsCookie.get('statistics_cookies_consent');
    if (cookie_consent && typeof gtag === 'function') {
      const list_name = location.pathname.substring(1) ? location.pathname.substring(1).replaceAll('/', '-') : 'landing';
      // eslint-disable-next-line no-undef
      gtag('event', 'select_item', {
        item_list_id: list_name,
        item_list_name: list_name.replaceAll('-', ' '),
        items: [product]
      });
    }
  }

  viewCart(products) {
    const cookie_consent = !!JsCookie.get('statistics_cookies_consent');
    if (cookie_consent && typeof gtag === 'function') {
      const total_price = _.sumBy(products, 'price');
      // eslint-disable-next-line no-undef
      gtag('event', 'view_cart', {
        currency: 'EUR',
        value: total_price,
        items: products.map(product => ({
          item_id: product.id,
          item_name: product.name,
          price: product.price,
          quantity: product.quantity,
          item_brand: 'FL Technics Training',
          item_category: product.category || ''
        }))
      });
    }
  }

  beginCheckout(products) {
    const cookie_consent = !!JsCookie.get('statistics_cookies_consent');
    if (cookie_consent && typeof gtag === 'function') {
      const total_price = _.sumBy(products, 'price');
      // eslint-disable-next-line no-undef
      gtag('event', 'begin_checkout', {
        currency: 'EUR',
        value: total_price,
        items: products.map(product => ({
          item_id: product.id,
          item_name: product.name,
          price: product.price,
          quantity: product.quantity,
          item_brand: 'FL Technics Training',
          item_category: product.category || ''
        }))
      });
    }
  }

  addPaymentInfo(payment_method, products, cart_info) {
    const cookie_consent = !!JsCookie.get('statistics_cookies_consent');
    if (cookie_consent && typeof gtag === 'function') {
      // eslint-disable-next-line no-undef
      gtag('event', 'add_payment_info', {
        currency: 'EUR',
        value: cart_info.final,
        coupon: cart_info.voucher_code,
        payment_type: payment_method,
        items: products.map(product => ({
          item_id: product.id,
          item_name: product.name,
          price: product.price,
          quantity: product.quantity,
          brand: 'FL Technics Training',
          item_category: product.category || ''
        }))
      });
    }
  }

  addShippingInfo(products, cart_info) {
    const cookie_consent = !!JsCookie.get('statistics_cookies_consent');
    if (cookie_consent && typeof gtag === 'function') {
      // eslint-disable-next-line no-undef
      gtag('event', 'add_shipping_info', {
        currency: 'EUR',
        value: cart_info.final,
        coupon: cart_info.voucher_code,
        items: products.map(product => ({
          item_id: product.id,
          item_name: product.name,
          price: product.price,
          quantity: product.quantity,
          item_brand: 'FL Technics Training',
          item_category: product.category || ''
        }))
      });
    }
  }

  purchase(order, products) {
    const cookie_consent = !!JsCookie.get('statistics_cookies_consent');
    if (cookie_consent && typeof gtag === 'function') {
      // eslint-disable-next-line no-undef
      gtag('event', 'purchase', {
        transaction_id: order.id,
        value: order.revenue,
        tax: order.tax,
        shipping: order.shipping,
        currency: 'EUR',
        coupon: order.coupon,
        items: products.map(product => ({
          item_id: product.id,
          item_name: product.name,
          price: product.price,
          quantity: product.quantity,
          item_brand: 'FL Technics Training'
        }))
      });
    }
  }

  productSearch(search_term) {
    const cookie_consent = !!JsCookie.get('statistics_cookies_consent');
    if (cookie_consent && typeof gtag === 'function') {
      // eslint-disable-next-line no-undef
      gtag('event', 'search', {
        search_term: search_term
      });
    }
  }
}

export default new DataLayer();
